module.exports = {
  animals: {
    page_title: '动物资料库',
    choose_your_language: '请选择你的语言',
    determine: '确定',
    noData: '敬请期待',
    do_you_know: '你知道吗',
    scientific_name: '学名',
    family: '科',
    diet: '飲食',
    food: '食物',
    habitat: '栖息环境',
    location: '分布区域',
    group_name: '綱',
    lifespan: '寿命',
    classification: '分类',
    date_of_naming: '命名日期',
    order: '目',
    weight: '重量',
    size: '尺寸',
    top_speed: '最高速度',
    endangered_level: '濒危程度',
    fossils_discovered: '发现化石',
    species: '物种',
  },
  btnText: {
    request: '请求失败！',
    delete: '删除',
    deleteInfo: '删除与否？',
    signout: '登出',
    signoutInfo: '登出？',
    loginSuccess: '登陆成功！',
    regSuccess: '注册成功',
    emailExist: '邮箱已存在',
    activaSuccess: '已成功激活',

    delCart: '您确定要删除此产品吗？',
    confirm: '确认',
    cancel: '取消',
    tip: '提示',

    setSuccess: '设置成功',
    addSuccess: '添加成功',
    editSuccess: '编辑成功',
    delSuccess: '删除成功',
  },
  top: {
    animalsBucket: '桶装动物模型',
    animalsBox: '动物模型套装',
    animalsPuzzle: '动物拼图',
    others: '其他',
    sales: '优惠产品',
    sale: '促销',
    animal: '动物资料库',
    collections: 'Wenno 系列',
    product: '产品',
    shop: '所有产品',
    about: '品牌故事',
    downloadApp: '下載應用程式',
    blog: '博客',
    btn: '立即购买',
    selRegion: '选择地区',
    contentTip: '搜索',
    followUs: '关注我们',
    dinosaurs: '恐龙系列',
    wildAnimals: '野生系列',
    farmAnimals: '农场系列',
    oceanAnimals: '海洋系列',
    dinosaursKeyword: '恐龙',
    wildAnimalsKeyword: '野生',
    farmAnimalsKeyword: '农场',
    oceanAnimalsKeyword: '海洋',
  },
  footbar: {
    f1: '免费送货',
    f1info: '订单金额超过$200.00HKD',
    f2: '轻松学习',
    f2info: '丰富语言和动物知识',
    f3: '关爱地球',
    f3info: '促进环保意识',
    f4: '安全环保',
    f4info: '由无毒和可回收材料制成',
    signup: '注册',
    footer: 'Wenno通讯以接收我们的最新消息。',
    input: '输入您的电子邮件',
    about: '关于我们',
    privacy: '私隐条款',
    terms: '服务条款',
    shipping: '送货服务',
    contact: '联络我们',
    subscribe: '电子订阅',
    btnSubscribe: '订阅电子报',
  },
  dialog: {
    login: '登录',
    logIn: '登录',
    signup: '注册',
    loginOrSignup: '登录/注册',
    cart: '购物车',
    phoneNumber: '联系电话',
    accountNo: '账号',
    loginEmail: '邮箱登录',
    loginPhone: '用手机号码登录',
    registerSuccess: '注册成功,激活邮件已经发至您的邮箱,请注意查收',

    name: '名称',
    email: '电子邮件地址',
    pass: '密码',
    cpass: '确认密码',

    code: '验证码',
    char: '输入6个字符或更多',

    forgot: '忘记密码？',
    deng: '登录',
    reg: '注册',
    sub: '提交',
    guest: '作为客人购买',
    newsletterCheck: '让我们变得更亲近！我们只会向您传送好东西。',
    agreeTerms: 'By creating your account, you agree to our terms and conditions & privacy policy',
    forgotTitle: '忘记密码',
    account: '还没有帐号吗？',
    signWith: '注册',
    google: '谷歌',
    face: '脸书',

    pname: '请输入你的名字',
    pemail: '请输入您的电子邮件',
    pvemail: '请输入有效电子邮件',
    ppass: '请输入密码',
    p6pass: '密码必须至少6位数字',
    pcpass: '请再次输入密码',
    ptpass: '两次输入的密码不一致！',
    pcode: '请输入验证码',
    pselect: '请选择',
    pselectinfo: '请选择区号',
    pphone: '请输入您的联系电话',
    warn: '继续创建您的账户，表示您同意我们的',
    terms: '条款及细则',

    phoneVerification: '手机验证',
    codeTo: '验证码已发送至',
    checkCode: '请查阅您的信息以取得四位数的验证码，并于下方输入',
    sendAgain: '重新发送验证码',
  },
  product: {
    productline: '产品线',
    ancient: '古代',
    sea: '海洋',
    land: '陆地',
    ar: '虚拟实境 (AR)',
    arinfo: '不只是动物！通过互动游戏探索Wenno AR！',
    whyar: 'Wenno和AR？',
    whyarl: '玩Wenno动物玩具是一个有趣，富教育性和互动性的学习体验。',
    whyarr: '与手机应用程序配合，显示不同动物的资料。',
    whyarerr: '您的浏览器不支持此短片',

    detail: '产品详情',
    addcart: '添加到购物车',
    details: '产品详情',
    bestSeller: '暢銷產品',
  },
  index: {
    freeDeliveryBar: '消费满港币 $200可免基本运费。(香港地区）',
    how: 'Wenno如何运作？',
    howtitle1: '虚拟实境',
    howinfo1: '使用Wenno手机程式，您可以随时随地进行游戏！我们在每个包装盒中提供的游戏卡上印有一二维码。通过将这些卡片与移动设备连接，可以显示有关每只动物的更多详细信息，例如动物的栖息地，生活环境和有趣的事实。同时可以培养幼儿的环保意识。',
    howtitle2: '英语学习',
    howinfo2: '这不仅仅是一套玩具。我们精美的非洲动物模型不止令人印象深刻，配合手机使用，它们会变得更多功能！套装随附小型游戏卡-只需将Wenno应用程序下载到您的iOS或Android设备上，然后扫描游戏卡即可。每个型号都有对应的游戏卡，可在您的手机上显示有趣的动物事实，资料和互动信息！可以尽情玩耍之余，也可以学英语！',
    howtitle3: '动物模型',
    howinfo3: '基于我们现代世界的7大洲和5大洋。我们还引用了濒危和灭绝的动物，以及最受欢迎的中生代恐龙、传统野生动物、农场动物和海洋生物系列中。',
    why: '为什么选择Wenno？',
    whytitle1: '好玩',
    whyinfo1: '我们提供的材料可以让小朋友动手制作和进行游戏！',
    whytitle2: '方便',
    whyinfo2: '您只需要：移动设备，Wenno产品和说明书，即可展开您的奇妙旅程！',
    whytitle3: '教育性',
    whyinfo3: '资深教育心理学家推荐Wenno®应用程式和产品，「这是一种非常有用的亲子工具，提供超过100多种详细的动物资讯」。',
    review1: '物超所值！',
    reviewname1: '- Thomas',
    review2: '最好的玩具！',
    reviewname2: '- Anne',
    review3: '买到上瘾！',
    reviewname3: '- Sharon',
  },
  shop: {
    all: '全部',
    categories: '类别',
    sort: '排序方式',
    new: '新品',
    pricehl: '价格从高到低',
    pricelh: '价格从低到高',
    popular: '最受欢迎',
    buy: '立即购买',
    noData: '暂无数据',
    inventory: '库存',
    pieces: '件',
    noSku: '该商品暂无商品规格',
    plsku: '请先选择商品规格',
    payCodeExp: 'payCode已过期，支付码不再是可扫描的，请点击刷新payCode重新支付',
    payCodeErr: 'payCode获取失败，请重新下单或者在订单详情页面选择其他方式支付',
    filter: '排序方式',
    dinosaur: '恐龙',
    wildAnimals: '野生动物',
    farmAnimals: '农场动物',
    oceanAnimals: '海洋动物',
    guessYouLikeIt: '猜你喜欢',
  },
  cart: {
    shop: '购物车',
    detail: '详情',
    qty: '数量',
    price: '价钱',
    total: '总价：',
    checkout: '结算',
    back: '返回',
    empty: '购物车是空的。',
    goshopp: '去逛逛',
    coupon: '优惠券号码：',
    sure: '确定',
    remark: '请输入备注',
    selectAdd: '请选择收货地址',

    ship: '运费',
    free: '免费',
    charge: '收费',
    freexin: '订单满$200.00HKD免运费',
    code: '优惠券',
    grand: '累计',

    pcoupon: '请输入优惠券码！',
    country: '国家/地区',
    addaddress: '新增地址',
    sf: 'SF储物柜',
    checkOut: '结算',
    shipInfo: '订单信息',
    goback: '返回',
    continue: '继续支付',
    payment: '付款结果',
    paySuccess: '支付成功',
    payFail: '支付失败',
    continueShop: '继续购物',

    pregion: '请选择国家/地区',
    preceiver: '请输入收货人',
    paddress1: '请输入地址1',
    pphone: '请输入电话',
    pphone1: '请输入正确的电话',
  },
  about: {
    about: '关于',
    info1: '小朋友眼中，动物就是他们的好伴侣。 Wenno®️以此为出发点，多年来一直用心设计以小朋友为中心的动物模型，陪伴着他们成长，一同创造无数欢乐回忆并引导他们愉快地学习。\n\n我们深信，只要坚持信念并尽心设计，定必能为动物教具赋予更大意义，真正做到「More than just animals」。 ',
    info2: 'Wenno®️的创立，是始于我作为三孩父母的一种体会：我们相信玩具的作用不应只是用来消磨时间，而是应该具教育意义，让小孩能「从游戏中学习」。\n\n只要小朋友能投入游戏当中，自然能培养出自主学习兴趣，启发创意及多角度思考，过程中更可学习到不同知识和技能。于是，我们在1995年决定于香港成立 ，逐步以行动将想法实践，成为了一切的起步点。 ',
    info3: 'Wenno®️于2015年正式面世，延续着我们的初衷，秉持「FUN & LEARN」的原则，透过研发不同赋有教育意义的益智教具，激发小朋友对 STREAM 的兴趣，从小发掘他们多方面潜能，同时灌输爱护动物和保护地球观念。\n\n近年我们更为这种传统塑胶动物模型注入科技元素，包括AR小游戏，手机应用程式及全息投影等，透过更多互动让小朋友投入玩耍过程，丰富他们的生活。 ',
    info4: '我们明白家长对儿童产品安全性和品质必定有相当高要求，因此 Wenno®️ 的产品符合 EN71 和 ASTM 国际标准，并已通过 ISO9001 认证，以确保我们的产品质量保持高水准，让家长和小朋友都能玩得放心。同时我们绝对支持并严格遵守国际玩具业委员会商业行为准则（ICTI）的原则及要求。\n\n由于我们产品质量佳、耐用度高，即使小朋友长大后亦可以将玩具转赠予更加年幼的小朋友，甚至捐赠给有需要的人，让Wenno®️的意义延续，为更多小朋友带来快乐。 ',
    info5: 'Wenno®️ 庆幸得到各家长支持和小朋友喜爱，不断持续发展，现已在全球建立了分销、批发、零售、以及线上销售，成功发展至拥有自己的生产线及销售渠道。\n\n自我们成立以来，Wenno®️ 一直由家族管理和经营，希望将我们爱家庭的热情转化至业务中，一起迈向 Wenno®️ 的成功愿景。 ',
    info6: '为所有家庭提供安全和能负担的产品，是Wenno®️一直以来的使命，期望让家长在没有规限情况下给小孩尽情玩耍和学习。而为了让大众能更方便地将Wenno®️产品带回家，我们现已更新网页系统，并以崭新面貌提供一站式简易购物服务。\n\n通过我们多年努力与坚持，我们希望更多家庭能亲身体会到Wenno®️动物特别的意义，将「FUN & LEARN」意念融入生活，不论是为小朋友挑选礼物，还是想入手亲子游戏玩具时，都能第一时间想起我们，同时想起Wenno®️的宗旨——「More than just animals」。 ',
    since1: '(自2008年起)',
    text1: 'ICTI是负责玩具和儿童产品的供应链计划。透过合乎道德的玩具生产，为工人创造更美好的生活和建立更强大的行业。',
    since2: '(自2015年起)',
    text2: 'ISO14006（环境管理系统）是一项国际标准，它规定了一些准则，以帮助我们建立、记录、实施、保持和持续改善我们的生态设计管理，并将其作为环境管理系统的一部分。',
    since3: '(自2016年起)',
    text3: '商界社会责任倡议行为守则（BSCI）是领先的供应链管理系统，可支持我们在全球供应链的工厂内推动社会责任和改进。 BSCI实施保护劳工权利的国际劳工标准原则，例如国际劳工组织（ILO）的公约和宣言，联合国（UN）工商企业与人权指导原则，以及经济合作暨发展组织的跨国企业指引（OECD）。',
    since4: '香港Q唛优质产品计划（自2015年起）',
    text4: '香港Q唛优质产品计划是一项产品认证计划，公司在香港，中国大陆或澳门设有生产工厂。计划旨在为那些公司提供有效的质素管理体系，以生产出始终如一的优质产品。',
    since5: '香港D唛认证计划（自2019年）',
    text5: '「香港D唛认证计划」，简称「D-Mark」，旨在表彰那些已经建立了有效利用质量设计框架的公司。 D唛认可公司为追求卓越设计所做的努力，在公司中树立的设计和创造力文化。',
    since6: '香港杰出服务（2020）',
    text6: '香港杰出服务是一项独立的认证计划，以确保在各个客户服务领域提供优质的服务。通过顾客问卷、神秘顾客和管理系统检查，对服务提供商进行评估。',
    since7: 'Intertek STEM玩具验证计划（自2019年）',
    text7: '一个独特且值得信赖的标志，可为玩具制造商在整个供应链中提供全面质量保证，并向教育机构和消费者保证STEM学习玩具已达到最高质量和安全标准。',
    since8: '优质品牌（2019）',
    text8: '优质品牌支持具有社会责任感和环保理念的高品质和信誉良好的公司，为客户和社会创造价值，以建设一个可持续发展，繁荣的香港。',
    text9: '香港星级玩具大奖2018, 由am730 x mameshare颁发',
    text10: '香港工商业奖：睿智生产力奖是对通过精心计划和执行得当的生产力计划，而获得竞争优势的香港公司或组织的认可。获奖者必须证明自己的生产力不断得到显著的提高。',
  },
  account: {
    bank: '汇丰银行',
    bankname: '银行名称',
    accountnumber: '戶口号码',
    accountname: '戶口名称',
    phonenumber: '电话号码',
    paypalmessage: '通过 PayPal 付款',
    fpsID: 'FPS ID',
    account: '我的帐户',
    orderTrack: '订单与追踪',
    prefer: '偏好',
    logot: '登出',
    paytip: '付款方式：',
    accountD: '账户详情',
    personal: '个人资料',
    name: '名称：',
    email: '电邮：',
    pass: '密码：',
    passBtn: '更改密码',
    lang: '语言',
    oldpass: '原密码',
    newpass: '新密码',
    conpass: '确认密码',

    ppass: '请输入旧密码',

    edit: '编辑',
    add: '添加',
    sub: '提交',

    // paymentMethod: '支付方式',
    addressBook: '地址簿',
    paymentMethod: '支付方式',
    shippAddress: '帐单/送货地址',
    consignee: '收货人',
    address: '地址',
    operate: '操作',

    receiver: '收货人',
    phone: '电话',
    company: '公司（可选）',
    region: '地区',
    address1: '地址1',
    address2: '地址2',
    emailadd: '电子邮件',
    area: '大区',
    district: '小区',
    search: '搜索',

    receiverR: '收货人为必填项',
    phoneR: '电话为必填项',
    regionR: '地区为必填项',
    address1R: '地址1为必填项',

    subscre: '订阅',
    SubscribeNew: '订阅新闻信息',
  },
  blog: {
    blog: '博客',
    detail: '博客资讯',
  },
  order: {
    detail: '订单详情',
    list: '订单',
    info: '产品详情',
    price: '单价',
    qty: '数量',
    tprice: '总价',
    status: '状态',
    operate: '操作',
    check: '查看订单',
    name: '收货人',
    phone: '电话',
    shippAddress: '收货地址',
    orderNote: '备注',
    orderNo: '订单号',
    logstatus: '物流状态',
    logInfo: '物流信息',
    logDetail: '物流详情',
    total: '总价',
    orderStatus: '订单状态',
    refund: '退款',
    paid: '已支付',
    close: '已关闭',
    approving: '审核中',
    unpaid: '未支付',
    readyToShip: '有待出货',
    receiptRejected: '收据被拒绝',
    confirmReceipt: '确认收货',
    receipt: '收据',
    totalpieces: '共 {amount} 件',
    empty: '空白',
    productDeleted: '商品过期不存在',
    uploadBtn: '上传转账凭证',
    uploadTip: '请先上传凭证',
    uploadTip1: '上传图片只能是 JPG GIF PNG JPEG 格式!',
    uploadTip2: '上传图片大小不能超过 2MB!',
    uploadSuc: '上传凭证成功，等待审核结果',
    uploadErr: '上传凭证失败',
  },
  footer: {
    info: '使用本网站即表示您接受WENNO网站的',
    tc: '条款及细则',
    title: '此等条款及条件构成 　阁下与我们之间具法律约束力之协议。阁下确认及同意此等条款及条件适用于阁下进入及使用本网站以及透过本网站提供之服务。阁下进入或使用本网站或使用服务，即表示阁下已阅读及明白此等条款及条件以及同意受其约束。',
    infotitle1: '1.  私隐声明',
    info1: '我們的私隱聲明載於本網站並適用於閣下以及閣下使用本網站及服務。',
    infotitle2: '2.  条款及条件之修订',
    info2: '我们保留不时修订此等条款及条件之权利。任何修订于本网站 发布通知后即告生效。阁下于发布通知后继续使用本网站及服务即表示阁下同意受经修订之条款及条件所约束。',
    infotitle3: '3.  帐户',
    info3: '阁下如欲于本网站购买产品，可以建立一个帐户并填妥我们要求的所有资料。阁下必须为每个帐户设立密码，以及可联络阁下的有效登入电邮地址。阁下有责任将阁下之密码保密。此外，阁下须为阁下或使用阁下登入电邮地址之任何其他人士之任何及全部活动负责。阁下可按照本网站之指示随时更改阁下之密码。建立帐户及使用服务须符合以下条件： (a) 阁下有能力订立有法律约束力之合约；(b) 阁下持有有效电邮地址；及(c) 阁下并非以任何其他人士的受托人身份行事。',
    infotitle4: '4.  订单',
    info4: '任何透过本网站进行的产品订购，为阁下于订购时以该等产品之价格（连同所有适用运费及税项）购买该等产品之要约。若我们就任何订单提出要求，阁下必须向我们提供任何额外详情及／或确认阁下之详情 。阁下透过本网站进行订购时，必须向我们提供完整及准确的资料。阁下在本网站订购产品时有责任遵守所有适用法律 （包括任何最低年龄规定）。我们或会行使绝对酌情权拒绝阁下之订单（包括但不限于订单内的任何产品缺货、如本网站内的产品价格或描述有错漏或无法就订单进行付款）。如我们拒绝阁下之订单，我们将尽力于合理时间内通知阁下。我们会就每项我们接纳的订单向阁下发出确认电邮。我们可于以下情况随时取消全部或任何部分之订单（包括我们已接纳的任何订单）而无须向阁下承担责任：(a) 订单内的任何产品缺货；(b) 本网站内就订单内任何产品之价格或描述有错漏；(c) 我们合理地相信阁下违反本协议之任何条款或条件；或 (d) 无法就订单进行付款。若我们取消任何订单，我们将尽力向阁下提供合理通知。我们不会就我们所取消的订单的任何部份向阁下收费。',
    infotitle5: '5.  送货',
    info5: '阁下同意遵守我们于本网站所载之所有派送规定（包括但不限于任何派送地点限制）。我们或会就若干产品联络阁下以作出派送安排。我们仅会于有人在派送地址进行接收时派送阁下订购之产品。我们或会要求接收阁下所订产品的人士向我们出示身份证明及／或订购时付款所用的信用卡（如适用）。如无人在派送地址接收阁下订购之产品，我们将尽力联络阁下，阁下或可联络我们，以安排于另一时间派送。我们可能就再派送阁下订购之产品向阁下收取额外派送费用。阁下确认及同意在派送地址收取所订购商品的任何人士皆获阁下授权收取阁下订购之产品 。在本网站订购产品的风险及所订购产品的所有权于派送至阁下的派送地址时即转移至阁下。',
    infotitle6: '6.  退货',
    info6: '所有在本网站订购的产品之退货均受我们为本网站所订立的退货政策所规限。',
    infotitle7: '7.  费用及收费',
    info7: '我们将向阁下收取而阁下同意支付于本网站订购的每件产品之价格连同所有运费及税项，以及此等条款及条件中所载之任何其他费用及收费。产品之价格于阁下进行订购时显示于本网站，并且包含商品服务税。产品之价格不时变动。在此等条款及条件规限下，我们一旦接纳阁下之订单，我们将不会变更订单内产品之任何价格。 同一件产品之价格或有别于我们任何门巿内之价格，而且我们没有义务配合我们门巿或任何第三者之任何定价。',
    infotitle8: '8.  付款',
    info8: '所有付款均由安全伺服器进行，且作为保安措施每宗交易均会加密，以及所有付款均只能以港币进行。阁下可使用PayPal来支付获接纳之订单。倘我们未能成功处理阁下订单之付款，我们或会拒绝或取消阁下之订单。若阁下选择以信用卡付款，即代表阁下授权我们从阁下指定信用卡中扣除获接纳订单应付之金额。阁下不得透过任何欺诈或非法途径为产品付款或试图付款。',
    infotitle9: '9.  服务',
    info9: '我们不声明或保证我们的网站或服务将不受干扰或零错处或零缺陷。我们不向阁下声明或保证透过本网站或服务取得的任何电子档案将不存在有害代码。',
    infotitle10: '10.  保安',
    info10: '阁下确认尽管我们一方已采取所有合理措施，阁下透过阁下的电脑系统或本网站所传送的数据或资料，仍存在被人擅自取用或更改的风险。在法律允许的最大范围内，我们不会就该等行为引致阁下或阁下因此蒙受之任何损失承担责任。',
    infotitle11: '11.  服务之更改',
    info11: '我们保留于我们认为必需或适当时就服务作出任何更改之权利。我们将尽所有合理努力于本网站预先通知该等更改，唯阁下确认并非所有更改皆可以预先通知（包括但不限于为补救本网站之错处或缺陷而作出之任何紧急且必要之更改）。',
    infotitle12: '12.  合法使用',
    info12: '阁下必须仅为合法目的使用本网站及服务，并确保阁下进入或使用本网站及服务并非不合法或受法律禁止。阁下有责任于使用本网站及服务时遵守所有适用法律。阁下同意于任何时间处理透过本网站提供或取得的任何资料或材料时，以遵守香港或任何其他相关司法管辖区所有适用法律的方式进行。',
    infotitle13: '13.  不当使用资料',
    info13: '阁下不得以任何方式不当使用本网站或任何于本网站发布的材料（包括但不限于以任何方式修改、复印、复制、再版、上载、发布、传送或分发任何材料的全部或任何部分，除非获此等条款及条件明确许可，或于正常使用服务下可合理预计的情况）。阁下不得干扰或破坏（或意图干扰或破坏）任何与本网站连接的伺服器或网络。',
    infotitle14: '14.  本网站资讯',
    info14: '我们不会就阁下拟使用的本网站内任何资讯之准确性、完整性或适当性作出保证或声明。　阁下须就使用从本网站取得的任何资讯承担责任。阁下应亲自作出查询以核实本网站之资讯对阁下的预期用途而言是否准确、完整及适当。材料内所有资讯仅属一般性质且并无构成专业意见的意图。本网站或载有包含其他人士观点或建议的资讯，其不一定代表我们的观点。本网站载有第三方维护之互联网网站之连结及标示。该等第三方网站之连结为便利　阁下而提供。该等连结并不由我们控制，且我们不对任何连结网站或连结网站内包含的任何连结之内容（包括对阁下的预期用途而言的准确性、完整性或适当性）承担责任。我们不认可该等连结网站内任何资讯或任何关连组织、产品或服务。',
    infotitle15: '15.  免责声明',
    info15: '在法律允许的最大范围内，我们不会就(a) 阁下取用或使用服务、本网站、任何材料或任何连结网站；(b) 阁下依赖任何材料作出的任何决定或行动；(c) 本网站或服务任何错处或缺陷；或(d) 任何产品订单所引起或与之有关连而不论是阁下引致（包括基于我们的疏忽）、蒙受或招致之任何损失（包括利润损失或间接、相应、附带、特殊、惩戒性或惩罚性损失或损害）承担责任。上述免责声明并非试图或意图免除某程度上不能合法地免除的任何法定责任。',
    infotitle16: '16.  法定保证',
    info16: '在法律允许的最大范围内，我们在任何担保、条件或保证（包括但不限于就可销售性、可接受品质、用途适用性或已知效果适用性之任何担保、条件或保证）之下或任何法例或基于任何法例隐含于本协议（法定保证）之下任何其他权利或补救之责任特此免除。当我们须承担任何法定保证下之责任时，以及任何法例废止或禁止合约内含有排除或修改法定保证之应用或行使或项下责任之条款时，我们就任何违反该等法定保证而承担的责任应限于由我们选择的以下一项或多项：(a)如违反涉及货品：更换货品或供应同等货品；维修该等货品；更换货品或获得同等货品的成本；或维修货品的成本；及(b)如违反与服务有关：再次提供服务或再次提供服务的成本。阁下确认及同意我们所依赖的此等责任限制于所有情况下属公平及合理。',
    infotitle17: '17.  不可抗力',
    info17: '我们不就任何延误或无法履行我们在本协议下的义务承担责任，如该等延误或不遵从乃由于超越我们合理控制的情况而引起。',
    infotitle18: '18.  弥偿',
    info18: '阁下同意弥偿及持续弥偿WENNO INTERNATIONAL LIMITED、其人员、雇员及代理（获弥偿者）所蒙受或招致之所有损失，而该等损失与(a) 阁下于本协议下任何义务或保证的任何违反；(b) 阁下任何故意不当行为；或(c) 阁下任何疏忽行为或遗漏有关。',
    infotitle19: '19.  版权',
    info19: '材料（包括但不限于文字、图像、标志、图标、声音纪录及软件）的所有版权由WENNO INTERNATIONAL LIMITED及其特许人拥有。由第三方取得的材料或涉及该第三方持有的版权。除明确授权并受版权法案下规定之条件所规限，或获此等条款及条件明确许可或因正常使用服务所合理预期外，于未获得我们或（材料属第三方所有之情况下）材料版权持有人明确书面许可下，阁下不得以任何形式或任何方式：(a) 将全部或任何部分材料复印、改编、复制、储存、分发、列印、展示、表演、刊发、向公众传达、向公众提供或制作衍生作品；或(b) 将全部或任何部分材料商业化。',
    infotitle20: '20.  商标',
    info20: '本网站使用之商标乃属WENNO INTERNATIONAL LIMITED之商标或注册商标。倘阁下使用任何我们的商标提述我们、本网站或服务，阁下必须包含一段商标乃属于我们的声明。阁下不得在以下情况下使用任何我们的商标：(a) 于阁下本身之商标内或作为阁下本身之商标的全部或部分；(b)与并非属于我们的任何业务、产品或服务有关；(c)一定程度上可能对其他人士构成混淆、误导或欺骗；或(d)一定程度上贬低我们、材料或本网站。',
    infotitle21: '21.  公开发表',
    info21: '阁下不得于未获我们事先书面许可下向公众发布任何有关我们的新闻公告、广告材料、宣传材料或任何其他形式的宣传。',
    infotitle22: '22.  终止',
    info22: '倘阁下违反此等条款及条件之任何条文，我们可终止本协议、阁下于本网站建立的任何帐户以及阁下进入本网站。我们可无须提供理由而运用酌情权终止本协议、 阁下于本网站建立的任何帐户以及阁下进入本网站之所有或任何部分。终止本协议将不会令本协议终结后仍然有效的条文终结。',
    infotitle23: '23.  一般条文',
    info23: '倘我们于某情况下放弃我们于本协议下全部或部分的任何权利，这不代表该等权利于任何其他情况下将自动被放弃。倘本协议任何条文基于任何原因被判定为无效、不能执行或不合法，则退而求其次解读至给予最大可能之效力，或倘其不能被赋予任何效力，则与本协议分割，从而使本协议余下部分仍然继续有充分效力。本协议将受香港法律约束。',
    infotitle24: '24.  释义',
    info24: '于此等条款及条件内，除文义另有所指外：',

    h1: '协议',
    p1: '指阁下与我们之间包含此等条款及条件之协议。 ',
    h2: '适用法律',
    p2: '指不时生效并与阁下使用、进入本网站及服务有关之任何及全部法规、规则、细则、条例或附属法例。',
    h3: '派送费用',
    p3: '指派送阁下订购产品之费用。每张订单的费用将取决于所订购产品的净购买金额及种类（尤其是产品的尺寸及重量）。',
    h4: '有害代码',
    p4: '指直接或间接有害或导致失效，或有助或能够导致未获授权取用或损坏数据的任何电脑病毒、木马程式、蠕虫病毒或其他电脑编码。',
    h5: '损失',
    p5: '指任何种类的任何损失或损害，包括但不限于对第三方负有的责任。',
    h6: '材料',
    p6: '指我们透过本网站提供的任何内容（包括但不限于资讯、数据、文件、图像、相片、图形、声音、影像或网络广播）。产品指本网站内宣传的每件产品。',
    h7: '服务',
    p7: '指我们透过本网站向阁下供应产品及提供相关服务。',
    h8: '本网站',
    p8: '指我们营运的https://www.wennoanimal.com/website/#/Index网站',
    h9: '税项',
    p9: '指与本协议下任何产品或任何交易有关的所有税项、征税、征费及收费。',
    h10: '我们、我们的',
    p10: '指WENNO INTERNATIONAL LIMITED。',
    h11: '阁下、阁下的',
    p11: '指使用本网站的任何人士。',
  },
  lion: {
    top1: '活动',
    top2: '解说指引',
    top3: '学习重点',
    title: '一家团聚的狮子',
    active: '引导孩子透过动物拼图认识狮子的世界里有雄性狮子，雌性狮子和幼狮子，究竟他们各自有什么角色。',
    list1: '请大家留意非洲大草原有什么动物，表示原来有狮子家族',
    list2: '思考狮子爸爸和狮子妈妈在这家族里扮演着怎样的角色。雌性狮子大多担任捕猎食物的角色及照顾幼狮子',
    list3: '而狮子爸爸则是一家之主，能保护一家的安全',
    list4: '透过幼狮子被受父母照顾的画面，让孩子也能联想到自己也受着爸爸妈妈的照顾。以此让孩子从狮子一家联想到自己的家庭，记起父母对自己的呵护和付出',
    list5: '同一时间，引导孩子思考在家里兄弟姐妹是否有互相关爱，与家人融洽地相',
    learn: '引导孩子明白每个成员在家庭中都有着不同的角色，分工合作，让大家学懂一家融洽相处的重要性，并教导孩子的成长之道，助他们在成长的道路上有最好的表现，健康快乐地往前进发。',
  },
  bear: {
    title: '能够面对逆境的大灰熊',
    active: '家长引导孩子在动物拼图活动中认识大灰熊如何经历春、夏、秋、冬的四个季节，究竟它们有怎么样的难题及生活方式。',
    list1: '栖息于北美洲的大灰熊，于一年四季都要以不同方式生活',
    list2: '每当春天来临时，大灰熊会慢慢从冬眠中苏醒过来',
    list3: '大灰熊迎接炎热的夏天并进行觅食，会在这个产卵的季节于河流大量捕捉三文鱼',
    list4: '当秋季到来时，因为河流中的鱼儿会逐渐减少，大灰熊便会在树林中寻找野果充饥',
    list5: '最后，当寒冷的冬季到来时，大灰熊会寻找合适的洞穴进行冬眠休息，并静待明年春天的到来',
    learn: '引领孩子明白人生必定会遇到逆境，每当寒冬过后便会有春天的到来，冬必逢春。勇敢面对逆境后便会有温暖而美丽的春天到来。',
  },
  penguin: {
    title: '帝皇企鹅的父爱与母爱',
    active: '家长可引导孩子使用动物拼图，学会细心观察和认识企鹅爸爸与妈妈在孕育企鹅成长时所肩负的重任。',
    list1: '栖息于南极的帝皇企鹅妈妈,生命中身负怀孕的重大责任',
    list2: '当她诞下企鹅蛋后，便必须回到海里捕猎食物以补充体力',
    list3: '这时，企鹅爸爸需要使用双脚，承托及夹紧企鹅蛋',
    list4: '企鹅爸爸用自己的身体来保护并孵化小企鹅，还要在妈妈归来前抵受寒冷的天气和饥饿',
    list5: '经过孵化后，企鹅宝宝终于出生了',
    list6: '这时企鹅妈妈还未回来，企鹅爸爸需要用喉咙中腺体的分泌物喂养他们',
    list7: '最终，企鹅妈妈带着猎物回来时，企鹅爸爸便会和妈妈交换角色，出海觅食。',
    learn: '从以上的孕育故事，孩子可学懂父爱和母爱同样伟大，而且得悉父母养育孩子并不容易，从而让他们懂得感激父母养育之恩。',
  },
  sunfish: {
    title: '外型奇特的翻车鱼',
    active: '透过动物拼图，家长能够教导孩子世界上有种类繁多的鱼类它们各有特质，并认识他们各自以怎么的方法在海里前进。',
    list1: '一般的鱼类主要靠尾鳍及左右两侧的鱼鳍前后摆动作为前进的方式',
    list2: '但魔鬼鱼有别于一般鱼类，他们前进方式主要靠身体左右两侧上下摆动',
    list3: '外貌奇特的翻车鱼前进方式更为奇特，他们缺乏一般鱼类的尾鳍',
    list4: '左右鱼鳍亦细小得与身体不成比例，因此它的上下鱼鳍特别发达，以左右摇摆作为前进方式',
    list5: '由此可见，鱼类都会因应自己的身体特性发展出各式各样的活动形态及生活方式',
    learn: '令孩子从中明白不同人都拥有不同的短处和长处，继而教导孩子接受自己的个人特质，寻找适合自己的发展方向，尽展所长，各适其式。',
  },
  shinghing: {
    tab1: '关于我们',
    tab2: '联系我们',
    tab3: '免责条款',
    tab4: '成就与奖项',

    aboutInfo1: '公司简介',
    aboutInfo2: '成兴塑胶制品有限公司成立于 1995 年，主要业务包括设计及制造塑胶动物玩具。',
    aboutInfo3: '成兴塑胶制品有限公司成立于 1995 年，主要业务包括设计及制造塑胶动物玩具。近年透过引入新型 PVC 注射技术，以及向 ODM 及 OBM 转型 发展，为市场提供各类极具价格竞争能力的塑胶动物产品。',
    aboutInfo4: '睿智生产力成就',
    aboutInfo5: '2020+ 成兴智能工厂',
    aboutInfo6: '成兴管理层一直鼓励不同的项目和计划，推动业务发展和提升生产力。 2016 年自行制定及提出「2020+ 成兴智能工厂」，成为行业内OBM企业实施工业 4.0 的先锋。在工业 4.0 的概念和基础下，成兴建立起由塑胶化合物至成品的综 合生产线，并从三方面实现其智能工厂计划，包括:',
    aboutInfo7: '垂直整合:',
    aboutInfo8: '引入 ERP、MES、APS 及无纸化运作，将日常营运及生产数 据全面数码化',
    aboutInfo9: '横向集成:',
    aboutInfo10: '原材料生产水平数据化，并与全球化工原料增塑剂供应商连 接，更准确地控制及预测材料用量及库存数据',
    aboutInfo11: '合适的生产自动化:',
    aboutInfo12: '引入六轴自动化设备、优化及整合模具的设计及生产 程序，降低劳动力成本',
    aboutInfo13: '项目让成兴日常营运更为数码化，包括可实行数码化绩效管理，对生产状况进 行即时的纠正及预防措施，同时能更有效地进行原材料库存管理，减低风险。',
    aboutInfo14: '自主品牌及授权业务',
    aboutInfo15: '自 2000 年起，成兴通过发展自主品牌“维亮 (Wenno)”和“动物世界 (Animal World)”，成功向 ODM 及 OBM 业务转型。透过与世界知名品牌「国家地理」 合作，成兴成为 PVC 仿真动物玩具的全球授权商，由设计、制造、分销至零 售，涵盖整个业务链。同时，成兴利用自身的设计及生产能力，对这些品牌产 品组件实施了标准化，从实现规模效益。',
    aboutInfo16: '虽然欧美市场在过去数年表现不稳，但在有效的品牌管理下，项目的净利润、 成品价值以及毛利率均有稳定增长，“维亮(Wenno)”更于2015 年获得香港Q 唛优质产品认证。成兴同时取得了BSCI、ICTI、ISO 9001和ISO 14006等多 项认证，所有产品均符合 EN71 和 ASTM 标准或相关分销国家特定安全标准。',

    contactInfo1: '香港办公室和陈列室',
    contactInfo2: '联系人︰吴先生',
    contactInfo3: '香港九龙尖沙咀东部么地道67号半岛中心11楼1106室',
    contactInfo4: '(852) 2464 8378',
    contactInfo5: 'info@shtoys.com.hk',
    contactInfo6: '(852) 2463 6704',
    contactInfo7: '展览会',
    contactInfo8: '我们每年都会参加一些世界著名的博览会，即香港玩具和游戏博览会，Spielwarenmesse（纽伦堡国际玩具博览会）。 如果您想在展会期间与我们预约，请随时给我们发电子邮件info@shtoys.com.hk。',
    contactInfo9: '我们期待与您会面！',
    contactInfo10: '电子目录',
    contactInfo11: '我们的产品目录现在可用。 展示我们所有安全且优质的塑料动物雕像，包括我们的自家品牌Wenno和授权品牌Animal Planet。',
    contactInfo12: '单击下面的下载电子版本（PDF格式）。 或者，请与我们联系以将复印件交付给您。',
    contactInfo13: '*请注意，您将需要免费的Adobe Reader来查看目录的PDF版本。',
    contactInfo14: '下载',

    termsInfo1: '下载任何文件即表示您接受以下条款和条件：',
    termsInfo2: 'Wenno™的版权由成兴塑料制造有限公司（成兴）拥有；其他版权可能由其他方持有。未经版权所有者的明确书面许可，严禁复制，修改，改编或以任何形式使用图像或信息。任何用途（包括但不限于复制，插图以及与成兴公司拥有版权有关的任何其他用途）都需要正式请求，并且必须以书面形式提出并发送至我们的联系电子邮件。',
    termsInfo3: '本文提供的信息是按“原样”和“可用”提供的。成兴对于通过http://www.shtoys.com.hk或通过http://www.shtoys.com.hk可获得的信息和数据不提供任何明示或暗示的保证，包括所有隐含的保证和条件或适销性，质量或特定用途的适用性，所有权和不侵权，并且不对目录中包含的信息的准确性做任何陈述。网站和这些目录中的材料以及用户对它们的访问可能会有所更改，恕不另行通知。',
    termsInfo4: '成兴，包括其高级管理人员，董事会成员和代理人，对任何形式的损害或损失，包括但不限于因使用本文中提供的信息或材料而产生或与之相关的损害或损失，不承担任何责任；或因依赖本文提供的任何信息或材料的准确性或及时性而产生；或因查看，分发或复制本文提供的任何信息或材料而产生或与之相关。',
    termsInfo5: '成兴所有作品©2019成兴塑料制造有限公司。保留所有权利。',

    awardsInfo1: '香港优质服务（2020）',
    awardsInfo2: '优质服务计划是一项独立的认证计划，以确保在各个客户服务领域提供优质的服务。可以通过“客户调查”，“神秘购物者”和“管理系统检查”程序对服务提供商进行评估。',
    awardsInfo3: '香港D标志（自2019年）',
    awardsInfo4: '“香港D-Mark认证计划”，简称“ D-Mark”，旨在表彰那些已经建立了有效利用质量设计框架的公司。马克认可公司为追求卓越设计，在公司中树立设计和创造文化而做出的努力。',
    awardsInfo5: 'Intertek STEM玩具商标验证计划（自2019年）',
    awardsInfo6: '一个独特且值得信赖的标志，可为玩具制造商在整个供应链中提供全面质量保证，并向教育机构和消费者保证STEM学习玩具已达到最高的质量和安全标准。',
    awardsInfo7: '优质品牌（2019）',
    awardsInfo8: '优质品牌支持具有社会责任感和环保理念的高品质和信誉良好的公司，为客户和社会创造价值，以建设一个可持续发展，繁荣的香港。',
    awardsInfo9: 'am730 x mameshare（2018）颁发的“最佳教育玩具品牌”玩具奖，2018年',
    awardsInfo10: '成兴：2018年香港工商业奖的智慧生产力奖（2018）',
    awardsInfo11: '香港工业奖：智慧生产力是对那些通过精心策划和执行的生产力计划获得竞争优势的香港公司或组织的认可。获奖者必须不断证明其生产力得到了显着提高。',
    awardsInfo12: '首席执行官吴Cal文先生：香港创新技术与制造业联合会2018年新一代奖（2018）',
    awardsInfo13: '“新一代”成就奖旨在表彰获奖者在研发，创新和他们在企业发展中所取得的成就方面所做的努力。',
    awardsInfo14: 'BSCI（企业社会合规倡议）合规（自2016年起）',
    awardsInfo15: '商业社会责任合规倡议（BSCI）是领先的供应链管理系统，支持我们在全球供应链的工厂内推动社会责任合规和改进。 BSCI实施保护劳工权利的国际劳工标准原则，例如国际劳工组织（ILO）的公约和宣言，联合国（UN）商业与人权指导原则以及经济合作组织和跨国公司的准则。发展（OECD）。',
    awardsInfo16: '香港Q标志产品计划（自2015年起）',
    awardsInfo17: '香港Q标志产品计划是一项产品认证计划，公司在香港，中国大陆或澳门设有生产工厂。该计划旨在为那些公司提供有效的质量管理体系，以生产出始终如一的优质产品。',
    awardsInfo18: '合并ISO14006环境管理体系（自2015年）',
    awardsInfo19: 'ISO14006是环境管理系统，是一项国际标准，它指定了一些准则，以帮助我们建立，记录，实施，维护和持续改善我们的生态设计管理，并将其作为环境管理体系的一部分。',
    awardsInfo20: 'GSV（全球安全验证）认证（自2012年起）',
    awardsInfo21: '全球安全验证（GSV）标准是Intertek制定的一项计划，旨在根据国际供应链安全要求帮助进口商和供应商评估其安全措施',
    awardsInfo22: 'ICTI CARE基金会合规性（自2008年起）',
    awardsInfo23: 'ICTI是负责玩具和儿童产品的供应链计划。我们的使命是通过合乎道德的玩具生产，为劳动者创造更美好的生活，并为更强大的行业服务。',
    awardsInfo24: 'ISO9000质量管理体系认证（自2000年起）',
    awardsInfo25: 'ISO 9000被定义为一组有关质量管理和质量保证的国际标准，旨在帮助公司有效地记录保持有效质量体系所需的质量体系要素。',
  },
  collections: {
    title1: 'Wenno动物纸盒套装系列',
    title2: 'Wenno动物桶装系列',
    title3: 'Wenno动物拼图游戏系列',
    subtitle1: '以逼真的动物模型 打开小朋友的想像世界',
    subtitle2: '实现孩子梦想中的「动物国度」',
    subtitle3: '一盒玩具3种玩法  多方面发掘小朋友潜能',
    info1: 'Wenno动物纸盒套装系列——绝对是孩子展现创意的最好工具！一盒附有多款逼真的动物模型，呈现出最真实的动物形态，令孩子们能瞬间投入到动物世界里，透过角色扮演开展自己的探险之旅。 \n\n不管是陆上、海洋的刺激历险，还是穿梭时空勇闯神秘的恐龙世界，Wenno动物模型都会是孩子最好的伙伴，而他们亦能透过游戏更了解动物的特征习性、栖息地等，无形间激发他们主动学习。立即给小朋友送上这份最好的礼物，激发一场场有趣的冒险旅程！ \n',
    info2: '要将家变成梦想中的动物国度？有Wenno动物桶装系列就随时都可以！我们不单止为孩子设计出最逼真、精致的动物模型，就连场景也为小冒险家预备好，多款动物模型及场景配件会陪伴孩子们游遍七大洲五大洋，经历意想不到的有趣故事，爸爸妈妈们千万不要低估孩子的创造力，放手让他们作主，打造属于他们的动物大世界，从旁引导他们去主动学习，透过游戏提高对动物的认知。 \n\n每套装均附有盖圆桶，收纳动物模型方便之余，更可培养小朋友自行收拾玩具的良好习惯。 \n',
    info3: '最好的玩具，就是够「好玩」、「耐玩」，且能引导孩子从中学习。 Wenno动物拼图游戏系列便将最好的集合起来，让孩子能与逼真的动物模型玩角色扮演之余，可同时挑战3级不同难度的动物拼图，甚至加入AR互动游戏与各位小冒险家斗智斗力，令探索动物世界变得前所未有地新奇有趣！ \n\n透过游戏，小朋友能了解动物的特征习性、栖息地等，激发他们主动学习，而玩拼图更是培养孩子专注力、手眼协调及逻辑思维的大好方法。从今天起，不妨与孩子一起投入游戏当中，真正寓教于乐！ \n',
  },
  privacy: {
    content: `
      <h3>我们收集什么样的信息？ </h3>
      <p>我们收集您的信息，当您在我们的网站上注册，下定单，订阅我们的资讯，或者回应的一项调查显示。 </p>
      <p>订货时或在我们的网站上注册，在适当情况下，你可能会被要求输入您的姓名，电子邮件地址，邮寄地址，电 话号码或信用卡信息。不过，您可以匿名访问我们的网站。 </p>
      <h3>我们如何使用您的信息吗？ </h3>
      <p>我们向您收集的任何信息，可以使用以下方式之一：</p>
      <p>要个性化你的经验（您的信息有助于我们更好地响应您的个性化需求）</p>
      <p>为了提高我们的网站（我们不断努力提高我们的网站产品的基础上，我们收到你的信息和反馈）</p>
      <p>为了提高客户服务（您的信息有助于我们更有效地响应客户服务请求和支持需求）</p>
      <p>要处理交易（你的信息，不论是公共或私人的，不会被出售，交换，转让，或以任何理由，任何其他公司未经 用户同意，除提供所购买的产品或服务要求的明确目的。）</p>
      <p>方便我们提供优惠，调查或改善其他网站功能</p>
      <p>定期发送电子邮件（您提供的电子邮件地址，订单处理，只会被用来向您发送信息和更新有关您的订单。）</p>
      <h3>我们如何保护您的信息？ </h3>
      <p>我们实施各种安全措施，保持您的个人信息的安全性，当你把一个命令或输入，提交或访问您的个人信息。 </p>
      <p>我们提供一个安全的服务器使用。提供的所有敏感/信用信息是通过 SSL技术，然后到我们的支付网关供应商数 据库加密传输只能够访问这种系统具有特殊访问权限授权，并须保持信息的机密。 </p>
      <p>交易后，你的私人信息（信用卡，安全号码，财务等）将不会被存储在我们的服务器上。 </p>
      <h3>我们使用cookies？ </h3>
      <p>（Cookies是一个网站或其服务提供者传输到您的电脑硬盘驱动器通过您的Web浏览器（如果你允许的话）， 使站点或服务供应商系统确认您的浏览器和捕捉并记忆某些信息的小文件</p>
      <p>我们使用cookie来帮助我们记住并处理您的购物车中的物品。 </p>
      <h3>我们向外界透露任何信息？ </h3>
      <p>我们不会出售，交易，或以其他方式转让向外界您的个人身份信息。这不包括受信任的第三方协助我们经营我 们的网站，开展我们的业务，或为您服务，只要各方同意保持这些信息的保密。我们也可以释放你的信息时， 我们认为是适当的释放遵守法律，执行我们的网站政策，或保护我们或他人的权利，财产或安全。然而，非个 人身份识别访客信息可以提供给其他方，市场营销，广告或其他用途。 </p>
      <h3>第三方链接</h3>
      <p>有时候，我们在网站，可能会提供第三方的产品或服务。这些第三方网站有单独的和独立的隐私政策。因此， 我们没有责任或义务，这些链接网站的内容和活动。尽管如此，我们力图保护的完整性我们的网站，并欢迎任 何反馈这些网站。 </p>
      <h3>符合加州在线隐私权保护法案</h3>
      <p>因为我们重视您的隐私，我们已经采取了必要的预防措施，以符合加州在线隐私权保护法案。因此，我们不会 未经您的同意向外界分发您的个人信息。 </p>
      <h3>符合儿童在线隐私保护法案</h3>
      <p>我们遵守COPPA（儿童在线隐私保护法案）的要求，我们不收集任何未满13岁人士的资料。我们的网站、产品 和服务对象都是至少13岁或以上的人。 </p>
      <h3>仅线上隐私权保护政策</h3>
      <p>本在线隐私政策仅适用于通过我们网站收集的信息，而不是离线收集的信息。 </p>
      <h3>付款安全</h3>
      <p>联款通是领先的，安全可靠的国际支付服务供应商的银行和网上商户自2000年以来客户的付款细节正在使用
      256位的扩展验证证书（安全地传输到收单银行，卡和支付公司进行实时交易授权EV）SSL加密交易。联款通支
      持CVV / CVC检查，以及Visa和MasterCard即3-D安全认证：VISA验证，万事达卡安全为客户和商户加入安全 保护。 </p>
      <h3>条款和条件</h3>
      <p>也请访问我们的<a href="#/T&C">条款和条件以及免责声明</a></p>
      <h3>您的同意</h3>
      <p>通过使用我们的网站，您同意我们的在线隐私政策。 </p>
      <h3>我们的隐私政策的更改</h3>
      <p>如果我们决定改变我们的隐私政策，我们将发布于此页面上和更新隐私政策的修改日期。 </p>
      <h3>查阅和改正</h3>
      <p>您可以随时要求查阅、复印，并要求我们修改，或要求我们停止继续收集、处理和使用，或删除您储存在我们记录的个人资料。如您想行使您的权利，请电邮致
        <a href="mailto:info@shtoys.com.hk">info@shtoys.com.hk</a>与我们联络。 </p>
`,
  },
  contactUs: {
    content: `
      <h3>客户服务:</h3>
      <p>电邮： <a href="mailto:info@shtoys.com.hk">info@shtoys.com.hk</a></p>
      <p>地址： 九龙尖沙咀么地道67号半岛中心1106室</p>
      <h3>开放时间：09:00-18:00</h3>
      <p style="color: red">**不设零售及购物，请于网站购买</p>
`,
  },
  deliveryService: {
    content: `
      <h3>我们可送货到哪里？ </h3>
      <p>Wenno  Shop所售卖的商品仅限于香港提供送货服务， 和不设退货或退款服务</p>
      <p>一般送货服务不包括香港的禁区范围或汽车需要特别通行证方可抵达之地区(如：西贡黄石码头)、
      香港国际机场(赤鱲角)及离岛 (如: 大屿山 (东涌、愉景湾及马湾除外)
      、坪洲、长洲、南丫岛、蒲台岛)。 </p>
      <p>未能提供送货服务到以下地点：社区治疗设施、社区隔离设施、社区隔离酒店。 </p>
      <h3>运费及预计送货时间 (网店购物)</h3>
      <p>Wenno Shop使用不同快递组合，以确保送货速度快，价格实惠，免费送货或一般送货服务预
      计送货时间约 3-7 个工作天。送货公司于送货当天致电客人确认。所有送货单必须签名。请确
      保有人于阁下提供的送货地址签收作实。 </p>
      <p>运费是根据订单金额（实价）计算。订单金额（实价）超过HK$200可获得免费标准送货服务</p>

      <table>
        <tbody>
          <tr>
            <td class="blue" colspan="2">订单金额（实价）</td>
            <td class="blue">(运费HK$)</td>
          </tr>
          <tr>
            <td class="blue">由</td>
            <td>至</td>
            <td rowspan="2">$50</td>
          </tr>
          <tr>
            <td class="blue">$1</td>
            <td>$199</td>
          </tr>
          <tr>
            <td class="blue" colspan="2">$200或以上</td>
            <td class="blue">免费</td>
          </tr>
        </tbody>
      </table>

      <p>电梯未能直达送货之地址，司机将尽可能驶至地址最近的停车处交收
      (例如：唐楼或村屋或独立屋在地下/停车场/村公所/牌方交收)。顾客须缴付「送货服务公司额外费用」
      (不设退款)，并需将费用以现金方式于到货时缴付给送货员。 </p>
      <h3>受疫情影响下的特别送货安排</h3>
      <p>基于现时新型冠状病毒疫情最新发展，我们会尽力处理及派送所有订单。
      惟部份订单或需要较长时间方可送达，希望顾客能够体谅。 </p>
      <p>为保障顾客及员工的安全，我们的送货服务将有特别安排。 </p>
      <p>部份订单会因应个别大厦情况及大厦管理人员的指示，安排货物放于门外、
      在大厦地下大堂交收或由管理处代收。送递公司人员会在送递前联络顾客作出安排。 </p>
      <p>如果送货地址所处大厦属「群组感染个案大厦」或被政府纳入「受限区域」，有关订单或会延迟派送，
      我们会确保地区安全及许可进入后安排送货。 </p>
`,
  },
};



// WEBPACK FOOTER //
// ./src/lang/zh-CN.js